import { parseDate } from "@lyfegen-platform/utils";
import { getYear } from "date-fns";
import { Maybe } from "../models/common/generic-types";

export const neo4jDateToDate = <VT extends Maybe<Date | string | null>>(value: VT): VT extends null | undefined ? null : Date => {
	if (!value) {
		return null as any;
	}

	if (value instanceof Date) {
		if (getYear(value as Date) === 0) {
			return null as any;
		}

		return value as any;
	}

	if (value) {
		return parseDate(value) as any;
	}

	return undefined as any;
};
